import { Stack, styled } from '@mui/material';
import { ReactNode } from 'react';
import { getGlassTintStyles, SUPPORTS_BACKDROP_FILTER } from 'src/constants/glass';

export const ChatInfoBackground = styled(Stack, {
  name: 'ChatInfoBackground',
  shouldForwardProp: (prop) => prop !== 'textColor' && prop !== 'bleed',
})<{
  textColor?: string;
  bleed?: boolean;
}>(({ theme, textColor, bleed }) => {
  const token = textColor ?? theme.palette.custom.OV.sys.secondary;
  const glass = getGlassTintStyles(theme, token);
  const { pxToRem } = theme.typography;

  return {
    color: token,
    background: glass.background,
    // Banners never compress when the dock is capped — only the card below shrinks/scrolls.
    flexShrink: 0,
    borderTopRightRadius: theme.shape.borderRadius,
    borderTopLeftRadius: theme.shape.borderRadius,
    // A non-last sheet extends down behind the next sheet's rounded top corners so there's no
    // seam; the negative margin cancels that extra height in layout.
    padding: bleed
      ? `${pxToRem(7)} ${pxToRem(9)} ${pxToRem(7 + theme.shape.borderRadius)} ${pxToRem(14)}`
      : `${pxToRem(7)} ${pxToRem(9)} ${pxToRem(7)} ${pxToRem(14)}`,
    marginBottom: bleed ? theme.shape.borderRadius * -1 : 0,
    fontSize: pxToRem(12),
    fontWeight: 600,
    position: 'relative',
    textWrap: 'wrap',

    backdropFilter: glass.backdropFilter,
    WebkitBackdropFilter: glass.WebkitBackdropFilter,
    border: glass.border,
    borderBottom: 0,
    [SUPPORTS_BACKDROP_FILTER]: glass.supportsFallback,

    '.timestamp': {
      opacity: 1,
    },
  };
});

export const ChatInfo = ({
  message,
  token,
  bleed = true,
}: {
  message?: ReactNode;
  token: string;
  bleed?: boolean;
}) => {
  if (!message) {
    return;
  }

  return (
    <ChatInfoBackground
      direction="row"
      alignItems="center"
      gap={1}
      textColor={token}
      bleed={bleed}
    >
      {message}
    </ChatInfoBackground>
  );
};
